/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AiModelTaskType
 */
export interface AiModelTaskType {
  /**
   *
   * @type {number}
   * @memberof AiModelTaskType
   */
  tabularMl: number;
  /**
   *
   * @type {number}
   * @memberof AiModelTaskType
   */
  singleTurnChat: number;
  /**
   *
   * @type {number}
   * @memberof AiModelTaskType
   */
  textGeneration: number;
  /**
   *
   * @type {number}
   * @memberof AiModelTaskType
   */
  informationExtraction: number;
  /**
   *
   * @type {number}
   * @memberof AiModelTaskType
   */
  conversationalAgent: number;
  /**
   *
   * @type {number}
   * @memberof AiModelTaskType
   */
  voiceAgent: number;
  /**
   *
   * @type {number}
   * @memberof AiModelTaskType
   */
  concierge: number;
}

/**
 * Check if a given object implements the AiModelTaskType interface.
 */
export function instanceOfAiModelTaskType(value: object): value is AiModelTaskType {
  if (!('tabularMl' in value) || value['tabularMl'] === undefined) return false;
  if (!('singleTurnChat' in value) || value['singleTurnChat'] === undefined) return false;
  if (!('textGeneration' in value) || value['textGeneration'] === undefined) return false;
  if (!('informationExtraction' in value) || value['informationExtraction'] === undefined) return false;
  if (!('conversationalAgent' in value) || value['conversationalAgent'] === undefined) return false;
  if (!('voiceAgent' in value) || value['voiceAgent'] === undefined) return false;
  if (!('concierge' in value) || value['concierge'] === undefined) return false;
  return true;
}

export function AiModelTaskTypeFromJSON(json: any): AiModelTaskType {
  return AiModelTaskTypeFromJSONTyped(json, false);
}

export function AiModelTaskTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiModelTaskType {
  if (json == null) {
    return json;
  }
  return {
    tabularMl: json['tabular_ml'],
    singleTurnChat: json['single_turn_chat'],
    textGeneration: json['text_generation'],
    informationExtraction: json['information_extraction'],
    conversationalAgent: json['conversational_agent'],
    voiceAgent: json['voice_agent'],
    concierge: json['concierge'],
  };
}

export function AiModelTaskTypeToJSON(value?: AiModelTaskType | null): any {
  if (value == null) {
    return value;
  }
  return {
    tabular_ml: value['tabularMl'],
    single_turn_chat: value['singleTurnChat'],
    text_generation: value['textGeneration'],
    information_extraction: value['informationExtraction'],
    conversational_agent: value['conversationalAgent'],
    voice_agent: value['voiceAgent'],
    concierge: value['concierge'],
  };
}
